// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3zOCE","location":"Header_location__1o8I1"};